import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children }) {
  const { isAuthenticated, getUserRole, loading } = useAuth();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Check authentication status
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin or admin_team
  const userRole = getUserRole();
  console.log("ProtectedRoute: User role is", userRole);

  if (userRole !== "admin" && userRole !== "admin_team") {
    console.log("ProtectedRoute: Access denied for role", userRole);

    // If user is investor, redirect to investor dashboard
    if (userRole === "investor") {
      return <Navigate to="/investor-dashboard" replace />;
    }

    // For other roles or no role, redirect to login
    return <Navigate to="/login" replace />;
  }

  console.log("ProtectedRoute: Access granted for role", userRole);
  return children;
}

export default ProtectedRoute;
